import React, { useEffect, useState } from "react";
import "./App.css";
// import about from "./about.json";

function App() {
  const [about, setAbout] = useState("");

useEffect(() => {

  fetch(
    "https://s3.us-east-1.amazonaws.com/akmehtaias.com/about.json?t=" + Date.now(),
    {
      method: "GET",
      cache: "no-store"
    }
  )
    .then(res => res.json())
    .then(data => {
      setAbout(data.about);
    })
    .catch(err => {
      console.error("About load error:", err);
    });

}, []);

  return (
    <div className="App">
      <main className="App-maina">
        <h3>{about || "Loading..."}</h3>
      </main>
    </div>
  );
}

export default App;